import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { DxButtonModule } from 'devextreme-angular';
import { AppGlobals } from 'src/app/app.globals';
import { GpdButtonComponent } from 'src/app/components/gpd-button/gpd-button.component';
import { SvgIconComponent } from 'src/app/components/svg-icon/svg-icon.component';
import { ConfigService } from 'src/app/services/config.service';

@Component({
    selector: 'app-config-project-timeline',
    imports: [CommonModule, DxButtonModule, GpdButtonComponent, SvgIconComponent],
    templateUrl: './config-project-timeline.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './config-project-timeline.component.css'
})
export class ConfigProjectTimelineComponent implements OnInit{
  @Input('hasAreaType') hasAreaType: boolean;
  @Input('hasProjectConfiguration') hasProjectConfiguration: boolean;

  constructor(
    private readonly router: Router,
    public readonly configService: ConfigService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.setIsConfigured();
    this.cdr.markForCheck();
  }

  async setIsConfigured() {
    const result = await this.configService.loadProjectConfigStatus(true);
    if (result == null) return;
    if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
    else{
      this.hasProjectConfiguration = result.hasProjectConfiguration;
      this.hasAreaType = result.hasAreaTypes;
      if(this.hasProjectConfiguration && this.hasAreaType){
        this.router.navigate(['/config/project-config/configuration']);
      }
    }
    this.cdr.markForCheck();
    
  }
  goToProjectConfiguration(): void {
    this.router.navigate(['/config/project-config/configuration']);
  }

  goToAreaType(): void {
    this.router.navigate(['/config/project-config/project-parameters']);
  }
}
